import { DatatableCell, Skeleton } from '@monksflow/monks-ui';
import clsx from 'clsx';

export interface TableSkeletonActionsCellProps {
  /** Optional layout-only className merged with the canonical `w-12`. */
  className?: string;
}

/**
 * Trailing actions-column skeleton cell — a `w-12` cell containing a
 * `size-8 rounded` `<Skeleton>` block, composed on monks-ui `DatatableCell`.
 *
 * It animates rather than sitting static, so the actions column does not read
 * as out of sync with the leading cells in the four tables that use it.
 */
export const TableSkeletonActionsCell = ({ className }: TableSkeletonActionsCellProps) => (
  <DatatableCell className={clsx('w-12', className)}>
    <Skeleton data-testid="skeleton-loader" className="size-8 rounded" />
  </DatatableCell>
);
TableSkeletonActionsCell.displayName = 'TableSkeletonActionsCell';
